import React, { useState, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, Checkbox, TableFooter, ButtonGroup, Button } from "@mui/material";
import SelectStatusButton from "../../commons/SelectStatusButton";
import CreateExtapiDialog from "./createExtapiDialog";
import UpdateExtapiDialog from "./updateExtapiDialog";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import AddIcon from "@mui/icons-material/Add";

/**Package */
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

/** API && Function */
import { getExtapies, updateExtapiStatus } from "../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Hook */
import { useParamFilter } from "../../commons/customHook";
import { useDispatch } from "react-redux";

const Extapies = () => {
  const location = useLocation();
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getExtapies);
  //filter
  const filter = convertQueryStringToObject(location.search);
  const [whichDialogOpen, setWhichDialogOpen] = useState(null); // nếu value là 'craete' thì mở dialog tạo, nếu value là data của row thì mở dialog update row đó

  //state
  const [changeIds, setChangeIds] = useState([]);

  const handleCreateResponse = (res) => {
    if (res.code !== 200) return;
    setWhichDialogOpen(false);
    console.log(res);
    setData((prev) => [...prev, res.data]);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateExtapiStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData(data.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };
  const handleUpdateResponse = (res) => {
    if (res.code === 200) {
      setData((prev) => prev.map((item) => (item.id === res.data?.id ? res.data : item)));
    }
  };

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN KẾT NỐI KHO NGOÀI HỆ THỐNG"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40 }}>
          <Button variant="outlined" onClick={() => setWhichDialogOpen("create")}>
            <AddIcon />
          </Button>
        </ButtonGroup>
      </div>
      {loading ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tổ chức")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Kho đầu nguồn")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Địa chỉ URL")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Account")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Thời gian đồng bộ")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length ? (
                data.map((row, index) => (
                  <TableRow
                    key={row.id}
                    hover
                    style={{ cursor: row.status === "DELETED" ? "" : "pointer" }}
                    onClick={(e) => row.status !== "DELETED" && e.target.type !== "checkbox" && setWhichDialogOpen(row)}
                  >
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.ogranization_name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.inventory_name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.url}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.account}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(row.sync_at).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t(isAllow ? "Không có dữ liệu" : "No permission")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <CreateExtapiDialog key={whichDialogOpen === "create"} open={whichDialogOpen === "create"} onClose={() => setWhichDialogOpen(null)} onCreateResponse={handleCreateResponse} />
      <UpdateExtapiDialog
        key={whichDialogOpen}
        open={whichDialogOpen && whichDialogOpen !== "create"}
        onClose={() => setWhichDialogOpen(null)}
        onSaveResponse={handleUpdateResponse}
        initialData={whichDialogOpen !== "create" && whichDialogOpen}
      />
    </div>
  );
};

export default Extapies;
